import type { PuzzleAttempt } from '../../types';

const K = 24;

/**
 * Estime le niveau du joueur sur les puzzles à partir de ses tentatives
 * (calcul type Elo simplifié, K=24) : chaque tentative fait évoluer
 * l'estimation vers le haut ou le bas selon le résultat (réussi du premier
 * coup ou non) et l'Elo du puzzle tenté — jamais un jugement de niveau
 * inventé.
 */
export function estimatePuzzleRating(attempts: PuzzleAttempt[], initial: number): number {
  let rating = initial;
  const sorted = [...attempts].sort((a, b) => a.timestamp.localeCompare(b.timestamp));
  for (const a of sorted) {
    const expected = 1 / (1 + 10 ** ((a.puzzleRating - rating) / 400));
    const actual = a.solvedFirstTry ? 1 : 0;
    rating += K * (actual - expected);
  }
  return Math.round(rating);
}

/**
 * Point de départ raisonnable avant toute tentative : Elo Chess.com (cadence
 * rapide de préférence) moins une marge, borné à une fourchette réaliste
 * pour des puzzles tactiques — sinon un point de départ neutre.
 */
export function initialPuzzleRating(chessComRating: number | null): number {
  if (chessComRating == null) return 800;
  return Math.max(600, Math.min(1500, chessComRating - 100));
}
